const state = () => ({
    list: [],
    tree: [],
    loading: false
})

const getters = {}

const actions = {
    async get({commit}) {
        commit('setLoading', true)
        try {
            const res = await this._vm.axios.get(this._vm.endpoints['module_note_category'])
            const {data} = res.data
            commit('setList', data || [])
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async getTree({commit}) {
        commit('setLoading', true)
        try {
            const res = await this._vm.axios.get(this._vm.endpoints['module_note_category_tree'])
            const {data} = res.data
            commit('setTree', data || [])
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        } finally {
            commit('setLoading', false)
        }
    },

    async add({commit, dispatch}, {formData}) {
        try {
            const res = await this._vm.axios.post(this._vm.endpoints['module_note_category'], {
                name: formData.name,
                parent_id: formData.parent_id || null,
                color: formData.color || null,
                tag_ids: formData.tag_ids || [],
                sort: formData.sort ?? null,
            })
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async update({commit, dispatch}, {id, formData}) {
        try {
            const payload = {}
            if (formData.name !== undefined) payload.name = formData.name
            if (formData.parent_id !== undefined) payload.parent_id = formData.parent_id
            if (formData.color !== undefined) payload.color = formData.color
            if (formData.tag_ids !== undefined) payload.tag_ids = formData.tag_ids
            if (formData.sort !== undefined) payload.sort = formData.sort

            const res = await this._vm.axios.put(this._vm.endpoints['module_note_category'] + '/' + id, payload)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },

    async delete({commit, dispatch}, {id}) {
        try {
            const res = await this._vm.axios.delete(this._vm.endpoints['module_note_category'] + '/' + id)
            return res.data
        } catch (error) {
            this._vm.onResponseFailure(error.response?.data)
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.loading = val
    },
    setList(state, data) {
        state.list = data
    },
    setTree(state, data) {
        state.tree = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
